import { render, staticRenderFns } from "./ImageColumn.vue?vue&type=template&id=d84eb2e8&scoped=true&"
import script from "./ImageColumn.vue?vue&type=script&lang=js&"
export * from "./ImageColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84eb2e8",
  null
  
)

export default component.exports